<div *ngIf="page_loaded">
  <div class="advisor-filter-section">
    <div class="advisor-performance-filter-section">
      <div class="each-table-filter-section">
        <span class="each-table-filter-label">Select Period</span>
        <mat-select
          class="each-table-filter-input"
          [(ngModel)]="selected_period"
          (selectionChange)="getGraphData()"
        >
          <mat-option [value]="'current month'">1 Month</mat-option>
          <mat-option [value]="'last 3 months'">Last 3 Months</mat-option>
          <mat-option [value]="'last 6 months'">Last 6 Months</mat-option>
          <mat-option [value]="'last 1 year'">Last 1 Year</mat-option>
          <mat-option [value]="'last 3 years'">Last 3 Years</mat-option>
          <mat-option [value]="'last 5 years'">Last 5 Years</mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div class="advisor-graphs-sections">
    <div class="each-advisor-graph-heading-section">
      <mat-checkbox
        [(ngModel)]="show_sales_graphs"
        (change)="createSalesGraphs()"
        >By Sales</mat-checkbox
      >
    </div>
    <div class="each-advisor-graph-heading-section">
      <mat-checkbox
        [(ngModel)]="show_product_graphs"
        (change)="createProductGraphs()"
        >By Products</mat-checkbox
      >
    </div>
    <div class="each-advisor-graph-heading-section">
      <mat-checkbox
        [(ngModel)]="show_customer_graphs"
        (change)="createCustomerGraphs()"
        >By Customer</mat-checkbox
      >
    </div>
  </div>
  <div *ngIf="show_sales_graphs">
    <p class="each-optimize-chart-heading">By Sales</p>
    <div class="each-optimize-chart-section">
      <div class="each-dashboard-graph-block-3">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Sales Amount</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="sales-amount-graph"></div>
        </div>
      </div>
      <div class="each-dashboard-graph-block-3">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Sales Count</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="sales-count-graph"></div>
        </div>
      </div>
      <div class="each-dashboard-graph-block-3">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Sales Type</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="sales-type-graph"></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="show_product_graphs">
    <p class="each-optimize-chart-heading">By Product</p>
    <div class="each-optimize-chart-section">
      <div class="each-dashboard-graph-block">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Product Group</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="product-group-graph"></div>
        </div>
      </div>
      <div class="each-dashboard-graph-block">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Product</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="product-graph"></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="show_customer_graphs">
    <p class="each-optimize-chart-heading">By Customer</p>
    <div class="each-optimize-chart-section">
      <div class="each-dashboard-graph-block">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>No. of Clients</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="customer-aum-graph"></div>
        </div>
      </div>
      <!-- <div class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Count</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="customer-count-graph"></div>
                </div>
            </div> -->
      <!-- <div class="each-dashboard-graph-block">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Financial Segment</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="financial-segment-graph"></div>
        </div>
      </div> -->
      <div class="each-dashboard-graph-block">
        <div class="portfolio-inner-heading-section">
          <img
            src="assets/events.png"
            class="portfolio-section-icon"
          />
          <span>Demographic Segment</span>
        </div>
        <div class="each-dashboard-graph-content">
          <div id="demographic-group-graph"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!page_loaded">
  <div class="ring">
    Loading
    <span></span>
  </div>
</div>
